import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import App from './App.vue';
import { router } from './router';
import { currentLocale, ELEMENT_LOCALES, i18n, setLocale } from './i18n';
import { registerSessionExpiredHandler } from './api/client';
import { useAuthStore } from './stores/auth';
import './styles/index.css';

const app = createApp(App);
sessionStorage.removeItem('dsv.returnToAdmin');
const pinia = createPinia();

app.use(pinia);
app.use(i18n);
// 默认small；高度由统一control token管理，输入、下拉与按钮保持同档。
// 需要大控件的场景自己声明（登录页 ElForm size="large"）。
app.use(ElementPlus, { size: 'small', locale: ELEMENT_LOCALES[currentLocale()] });
app.use(router);

// 初始化 body 上的语言类名（设计系统靠它切换中韩字体族）
setLocale(currentLocale());

// 令牌彻底失效时（刷新也救不回来），清会话并跳登录页。
// 注册在这里是为了让 axios 拦截器不必反向依赖 store 和 router。
registerSessionExpiredHandler(() => {
  if (sessionStorage.getItem('dsv.returnToAdmin')) {
    window.location.assign(import.meta.env.BASE_URL);
    return;
  }
  useAuthStore().clearSession();
  const current = router.currentRoute.value;
  if (current.name !== 'login') {
    void router.replace({ name: 'login', query: { redirect: current.fullPath } });
  }
});

app.mount('#app');
